import { PaymentMethodType } from '@nemuru-eng/js-api-client';

import { CheckoutSessionDetailEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/_shared/entities/CheckoutSessionDetailEntity';
import { AgentCard } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/Summary/Agent/AgentCard';
import { CheckoutSessionAutoCart } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/Summary/Cart/Auto/CheckoutSessionAutoCart';
import { CheckoutSessionCart } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/Summary/Cart/CheckoutSessionCart';
import { CheckoutSessionCustomer } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/Summary/Customer/CheckoutSessionCustomer';
import { FlexColumn } from '@/components/shared/components/FlexColumn';

interface CheckoutSessionSummaryProps {
  checkoutSessionDetailEntity: CheckoutSessionDetailEntity | undefined;
  paymentMethodType: PaymentMethodType;
}

export const CheckoutSessionSummary = ({
  checkoutSessionDetailEntity,
  paymentMethodType,
}: CheckoutSessionSummaryProps) => {
  if (!checkoutSessionDetailEntity || !paymentMethodType) {
    return null;
  }

  return (
    <FlexColumn gridGap={24}>
      {checkoutSessionDetailEntity.hasCart() &&
        (paymentMethodType === PaymentMethodType.AUTO_LOAN ? <CheckoutSessionAutoCart /> : <CheckoutSessionCart />)}
      <CheckoutSessionCustomer />
      <AgentCard agentId={checkoutSessionDetailEntity.agentId} merchantId={checkoutSessionDetailEntity.merchantId} />
    </FlexColumn>
  );
};
